import http from '@/utils/http'
import httpApi from '@/apis/httpApi'

export const getProTree = (data) => {
  return http.get({
    url: httpApi.debugModel.getProTree,
    data
  })
}
export const getProDetail = (data) => {
  return http.get({
    url: httpApi.debugModel.getProDetail,
    data
  })
}
export const getBarListNew = (data) => {
  return http.get({
    url: httpApi.debugModel.getBarListNew,
    data
  })
}